var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fragment"},[_c('UkrposhtaTableUser',{attrs:{"countFilterParams":_vm.countFilterParams,"filterGetParams":_vm.filterGetParams},on:{"createGroupF103A":_vm.checkCreateF103A,"resetFilter":_vm.resetFilter,"showMore":_vm.showMore,"changeFilter":_vm.changeFilter,"reload":_vm.reload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }